import type { ReactElement } from 'react';
import { t } from '@fetmode/i18n';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@fetmode/app-core';

/**
 * Studio app routes require a session. Guests are sent to the recruit home (`/`),
 * not deep into login — Sign in is an explicit nav action.
 */
export function StudioProtectedRoute({ children }: { children: ReactElement }): ReactElement {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <p>{t('common.auth.loading')}</p>;
  }

  if (!user) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return children;
}
